import { Component, OnInit, Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppRoutingService } from '../app-routing.service';
import { IHistoryItem } from '../state';
import { NgFor, NgIf } from '@angular/common';

interface IDebugMessageBase {
  type: string;
}

interface IDebugMessage extends IDebugMessageBase {
  message: string;
}
interface IRoutingDebugMessage extends IDebugMessageBase {
  keytype: string;
  key: string;
  historyItem: IHistoryItem;
}

@Component({
    selector: 'app-debug',
    templateUrl: './debug.component.html',
    styleUrls: ['./debug.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf]
})
export class DebugComponent implements OnInit {

  private channel: BroadcastChannel;
  items: IDebugMessage[];
  backHistoryItem: IHistoryItem;
  currentHistoryItem: IHistoryItem;
  backHistoryKey: string;
  currentHistoryKey: string;
  constructor() {
    this.items = [];
    this.channel = new BroadcastChannel('cobradebug');

    // this.channel.onmessage = this.processMessage;
    fromEvent(this.channel, 'message').pipe(
      map((evt: MessageEvent) => evt.data),
    ).subscribe((data: IDebugMessageBase) => {
      switch (data.type) {
        case 'routing':
          this.processRoutingDebugMessage(data as IRoutingDebugMessage);
          break;
        default:
          this.items.push(data as IDebugMessage);
          break;
      }
    });
  }

  processRoutingDebugMessage(data: IRoutingDebugMessage) {
    if (data.keytype === 'current') {
      this.currentHistoryItem = data.historyItem;
      this.currentHistoryKey = data.key;
    } else {
      this.backHistoryItem = data.historyItem;
      this.backHistoryKey = data.key;
    }
  }

  clear() {
    this.items = [];
  }

  ngOnInit() {
  }

  // processMessage = (evt: MessageEvent) => {
  //   console.log(evt);
  //   const data = evt.data as IDebugMessage;
  //   this.items.push(data);
  // }

}
